import { reducer as referralsBackoffice } from "./referrals-backoffice/slice";

export const reducer = {
  referralsBackoffice,
};
